import api from "../api";

const cart = { 
  items() {
    return new Promise((resolve, reject) => {
      api.get(
        "/cart/",
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  add(productId) {
    return new Promise((resolve, reject) => {
      api.post(
        `/cart/${productId}/`,
        {},
        data => setTimeout(() => resolve(data), 2000),
        error => reject(error)
      );
    });
  },
  decrement(productId) {
    return new Promise((resolve, reject) => {
      api.post(
        `/cart/${productId}/decrement/`,
        {},
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  removeProduct(productId) {
    return new Promise((resolve, reject) => {
      api.delete(
        `/cart/${productId}/remove/`,
        {},
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  updateQuantity({ productId, payload }) {
    return new Promise((resolve, reject) => {
      api.patch(
        `cart/${productId}`,
        payload,
        data => resolve(data),
        error => reject(error)
      )
    })
  },

  // offline
  sendLocalItems(content) {
    // TODO: remind backend developer to implement batch update functionality
    return new Promise((resolve, reject) => {
      api.post(
        "/cart/batch-update/",
        content,
        data => resolve(data),
        error => reject(error)
      );
    });
  },
  itemsOffline() {
    return new Promise((resolve) => {
      let cart = JSON.parse(localStorage.getItem("cart")) || []
      resolve(cart);
    });
  },
  addOffline(product) {
    let cart = JSON.parse(localStorage.getItem("cart")) || []

    return new Promise((resolve) => {
      if (cart.length > 0) {
        let cartItem = cart.find((item) => item.product.id == product.id);
        if (cartItem) {
          cartItem.quantity += 1;
          resolve(cart);
        } else {
          cart.unshift({ quantity: 1, product });
          resolve(cart);
        }
      } else {
        cart.unshift({ quantity: 1, product });
        resolve(cart);
      }
    });
  },
  decrementOffline(productId) {
    let cart = JSON.parse(localStorage.getItem("cart"));

    return new Promise((resolve, reject) => {
      if (cart.length > 0) {
        let cartItem = cart.find((item) => item.product.id == productId);
        if (cartItem.quantity > 1) {
          cartItem.quantity -= 1;
          resolve(cart);
        } else {
          let cartItemIndex = cart.findIndex((item) => item.product.id == productId);
          cart.splice(cartItemIndex, 1);
          if (cart.length === 0) {
            resolve(cart);
            localStorage.removeItem("cart");
          } else {
            resolve(cart);
          }
        }
      } else {
        reject("No cart item detected in localStorage");
      }
    });
  },
  removeProductOffline(productId) {
    let cart = JSON.parse(localStorage.getItem("cart"));

    return new Promise((resolve, reject) => {
      if (cart.length > 0) {
        let cartItemIndex = cart.findIndex((item) => item.product.id == productId);
        cart.splice(cartItemIndex, 1);
        if (cart.length === 0) {
          resolve(cart);
          localStorage.removeItem("cart");
        } else {
          resolve(cart);
        }

      } else {
        reject("No cart item detected in localStorage");
      }
    });
  },
};

export default cart;
